// ControlTimerAssetFactory.js

import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';
import propertyViewMapService from 'PropertyViewMapService.js';

import ControlModel    from 'ControlModel.js';
import AssetTimerView  from 'advanced-inputs/AssetTimerView.js';


//=============================================================================
//
// Creates a Timer control view. It will be rendered in the Asset Placeholder at the bottom of the editor window.
//
// Brad Trebilcock, February 22, 2016
//
//=============================================================================
class ControlTimerAssetFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes( factoryKey, pos ) ;

        attributes.direction = "up";
        attributes.startTime = "0";
        attributes.endTime = "60";
        attributes.time = "0";
        attributes.loop = "false";
        attributes.autoStart = "none";
        attributes.interval = "1";

        const view = new AssetTimerView( { model: new ControlModel( attributes ), el:constants.PAGE_ASSETS_ID, factoryKey: factoryKey, id: attributes.id} );

        return view;
    }

}

const controlTimerAssetFactory = new ControlTimerAssetFactory();

export default controlTimerAssetFactory;
